<template>
  <h2 class="h6 text-bold text-uppercase p-y-2 m-0">
    <slot/>
  </h2>
</template>

<script>
export default {
  name: 'about-section-heading',
};
</script>
